var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadphonesHead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0C6.725 0 2 4.73214 2 10.625V13.75C2 13.8393 2 13.8393 2 13.9286C2 14.0179 2 14.1964 2 14.2857C2 16.7857 3.925 18.75 6.375 18.75C6.9 18.75 7.25 18.3929 7.25 17.8571V10.7143C7.25 10.1786 6.9 9.82143 6.375 9.82143C5.4125 9.82143 4.45 10.1786 3.75 10.7143V10.5357C3.75 5.71429 7.6875 1.78571 12.5 1.78571C17.3125 1.78571 21.25 5.71429 21.25 10.625V10.7143C20.55 10.1786 19.5875 9.82143 18.625 9.82143C18.1 9.82143 17.75 10.1786 17.75 10.7143V17.8571C17.75 18.3929 18.1 18.75 18.625 18.75C19.2375 18.75 19.85 18.5714 20.375 18.3929C19.5 20.2679 17.925 21.6964 16 22.5C16 22.4107 16 22.4107 16 22.3214C16 21.7857 15.65 21.4286 15.125 21.4286H12.5C11.975 21.4286 11.625 21.7857 11.625 22.3214V24.1071C11.625 24.6429 11.975 25 12.5 25C18.275 25 23 20.3571 23 14.6429V13.75V11.6071V10.625C23 4.73214 18.275 0 12.5 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphonesHead);
export default __webpack_public_path__ + "static/media/headphones_head.d6d5ab38ef2396ae4ceedead942df7b2.svg";
export { ForwardRef as ReactComponent };